<cac-dialog-layout
  [title]="isEditMode ? (isNotEditable ? 'Edit System Rail' : 'Edit Rail') : 'Create New Rail'"
  (onSubmit)="onSubmit($event)">

  <div class="space-y-6">
    <!-- Basic Information Section -->
    <section class="space-y-4">
      <h3 class="text-lg font-semibold text-gray-800 border-b pb-8">Basic Information</h3>
      <cac-form-builder [options]="form"></cac-form-builder>
    </section>

    <!-- Products Section - Only show if NOT notEditable -->
    @if (!isNotEditable) {
      <section class="space-y-4">
        <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">Products</h3>

        <div class="bg-blue-50/50 border border-blue-200 rounded-xl p-4">
          <div class="mb-3">
            <h4 class="text-md font-semibold text-gray-900 mb-2">
              Add Products to Rail <span class="text-red-500">*</span>
            </h4>
            <p class="text-sm text-gray-600 mb-3">
              Search and select products to add them to this rail. Type product names to search.
            </p>
          </div>

          <app-lazy-dropdown
            [multiple]="false"
            [searchable]="true"
            [clearable]="true"
            [clearOnSelection]="true"
            [placeholder]="'🔍 Search for products...'"
            [hint]="'Type to search for products. Selected items will be added to the table below.'"
            [pageSize]="20"
            [apiAdapter]="productApiAdapter"
            [itemMapper]="productItemMapper"
            [excludeIds]="getSelectedProductIds()"
            idsFilterKey="ProductIds"
            searchField="EnglishName"
            [duplicateMessage]="'Product is already added to this rail'"
            (selectionChange)="onProductChange($event)"
            class="w-full">
          </app-lazy-dropdown>
        </div>

        <!-- Products Table -->
        <div class="border rounded-xl overflow-hidden">
          @if (selectedProductIds().length === 0) {
            <div class="text-center py-12 bg-white">
              <p class="text-gray-500 mb-2">No products selected yet</p>
              <p class="text-sm text-gray-400">Use the search dropdown above to find and add products</p>
            </div>
          } @else {
            <cac-table [options]="productsTable"></cac-table>
          }
        </div>
      </section>
    } @else {
      <!-- Message for non-editable rails -->
      <section class="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div class="flex items-start space-x-3">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
            </svg>
          </div>
          <div>
            <h4 class="text-sm font-semibold text-amber-800 mb-1">System Rail</h4>
            <p class="text-sm text-amber-700">
              This is a system-defined rail. You can only modify the name and priority.
              The products in this rail are managed automatically by the system.
            </p>
          </div>
        </div>
      </section>
    }
  </div>
</cac-dialog-layout>
